import {
  Payments_PaymentProcessorId as PaymentProcessorId,
  Payments_WalletType as WalletType,
} from '__generated__/graphql-types';

import PaymentProcessorTypes from 'bundles/payments-common/common/PaymentProcessorTypes';
import { PAYMENT_METHOD } from 'bundles/payments-common/utils/eventingUtils';

import _t from 'i18n!nls/account-settings';

export const getPaymentMethodType = (
  walletType: string | null | undefined,
  paymentProcessorId: string | null | undefined
) => {
  if (walletType) {
    switch (walletType) {
      case WalletType.GooglePay:
        return PAYMENT_METHOD.GOOGLE_PAY;
      case WalletType.ApplePay:
        return PAYMENT_METHOD.APPLE_PAY;
      case WalletType.Link:
        return PAYMENT_METHOD.LINK;
      default:
        return PAYMENT_METHOD.UNKNOWN;
    }
  } else {
    switch (paymentProcessorId) {
      case PaymentProcessorTypes.paypal:
        return PAYMENT_METHOD.PAYPAL;
      case PaymentProcessorTypes.braintree:
      case PaymentProcessorId.StripeConsumer:
      case PaymentProcessorId.StripeConsumerSandbox:
      case PaymentProcessorId.StripeBvConsumer:
      case PaymentProcessorId.StripeBvConsumerSandbox:
        return PAYMENT_METHOD.CARD;
      default:
        return PAYMENT_METHOD.UNKNOWN;
    }
  }
};

export const getActivePaymentType = (paymentProcessorId: string | null | undefined): string | null => {
  switch (paymentProcessorId) {
    case PaymentProcessorTypes.paypal:
      return _t('PayPal account');
    case PaymentProcessorTypes.braintree:
    case PaymentProcessorId.StripeConsumer:
    case PaymentProcessorId.StripeBvConsumer:
      return _t('credit card');
    case PaymentProcessorId.StripeConsumerSandbox:
    case PaymentProcessorId.StripeBvConsumerSandbox:
      return _t('credit card (sandbox)');
    default:
      return _t('payment method');
  }
};

export const getWalletDescription = (
  paymentProcessorId: string | null | undefined,
  email: string | null | undefined,
  creditCardType: string | null | undefined,
  creditCardLastFourDigits: string | null | undefined
) => {
  if (paymentProcessorId === PaymentProcessorTypes.paypal) {
    return _t('PayPal account #{email}', { email });
  }
  const brand = creditCardType || _t('card');
  const last4 = creditCardLastFourDigits;
  return last4 ? _t('#{brand} ending in #{last4}', { brand, last4 }) : _t('#{brand}', { brand });
};
